import { render, staticRenderFns } from "./QuotesOverview.vue?vue&type=template&id=48afc0e5&scoped=true&"
import script from "./QuotesOverview.vue?vue&type=script&lang=js&"
export * from "./QuotesOverview.vue?vue&type=script&lang=js&"
import style0 from "./QuotesOverview.vue?vue&type=style&index=0&id=48afc0e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afc0e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
